/**
 * Smoothly scroll to an element.
 *
 * @param {Map}  config   IE does not support default parameter, hence config hash.
 *   {String}   config['element']               Target element to move to.
 *   {String}   config['position']              'top' or 'bottom' of the element.
 *   {String}   config['offsetElement']         Add offset based on offsetElement height.
 *   {Integer}  config['manualOffset']          ignores offsetElement and add manualOffset instead.
 *   {String}   config['fixedAfterScroll']      Sticky Element after scroll.
 *   {String}   config['fixedSwitchElement']    offset where fixedAfterScroll element becomes sticky.
 *   {Integer}  config['fixedSwitchManual']     ignores fixedSwitchElement.
 */
export function scrollToElement(config: Map<any, any>) {
    let $target = document.querySelectorAll(config.get('element'))[0];
    let offset: number = 0;

    if (config.get('position') == 'bottom') {
        offset = offsetTop($target) + $target.offsetHeight;
    } else {
        offset = offsetTop($target);
    }

    // add offset based on another element or manually set one
    if (typeof config.get('manualOffset') !== 'undefined' && config.get('manualOffset') != '') {
        offset = offset + config.get('manualOffset');
    } else if (typeof config.get('offsetElement') != 'undefined' && config.get('offsetElement') != '') {
        offset = offset - document.querySelectorAll(config.get('offsetElement'))[0].offsetHeight;
    }

    // if scrolling triggers sticky element, calculate accordingly
    // offset where sticky applies
    var fixedOffset = 0;

    if (typeof config.get('fixedSwitchElement') != 'undefined' && config.get('fixedSwitchElement') != '') {
        fixedOffset = document.querySelectorAll(config.get('fixedSwitchElement'))[0].offsetHeight;
    } else if (typeof config.get('fixedSwitchManual') != 'undefined') {
        fixedOffset = config.get('fixedSwitchManual');
    } // remove sticky element form offset


    if (typeof config.get('fixedAfterScroll') != 'undefined' && config.get('fixedAfterScroll') != '' && window.pageXOffset <= fixedOffset) {
        offset = offset - document.querySelectorAll(config.get('fixedAfterScroll'))[0].offsetHeight;
    }

    // animate
    scroll({
        top: offset,
        behavior: "smooth"
    });
}


export function offsetTop(el: Element): number {
    let rect = el.getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let top: number = rect.top + scrollTop;
    return top;
}